/** Single source of truth for the deployed application version. Update when cutting a release. */
export const APP_VERSION = '1.0.3';
export const PREVIOUS_APP_VERSION = '1.0.1';
